import {Component, inject, input, model, output, signal, ViewEncapsulation} from '@angular/core';
import {DxDataGridModule, DxPaginationModule, DxPopupModule, DxTextBoxModule} from 'devextreme-angular';
import {SelectionChangedEvent} from 'devextreme/ui/data_grid';
import {ValueChangedEvent} from 'devextreme/ui/text_box';
import {SharedModule} from '../../../../../shared/shared.module';
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';
import {
  ProduitDeclinaisonComplementaireDTO
} from '../../../../../core/dtos/produit/declinaison/complementaire/produit-declinaison-complementaire-dto';
import {
  SelectionProduitComplementaire
} from '../../../../../core/models/gestion-produits/declinaison/complementaire/selection-produit-complementaire';
import {
  PlcProduitComplementaireService,
  PRODUIT_COMPLEMENTAIRE_PAGE_SIZE
} from '../../../../../core/services/entities/plc-produit-complementaire.service';
import {
  ProduitComplementaireParametrageService
} from '../../../../../core/services/entities/produit-complementaire-parametrage.service';

@Component({
  selector: 'yo-dialog-selection-produit-complementaire',
  templateUrl: './dialog-selection-produit-complementaire.component.html',
  styleUrls: ['./dialog-selection-produit-complementaire.component.scss'],
  standalone: true,
  imports: [DxPopupModule, DxDataGridModule, DxPaginationModule, DxTextBoxModule, SharedModule],
  encapsulation: ViewEncapsulation.None
})
export class DialogSelectionProduitComplementaireComponent {

  readonly PAGE_SIZE = PRODUIT_COMPLEMENTAIRE_PAGE_SIZE;
  readonly ButtonThemeEnum = ButtonThemeEnum;

  readonly visible = model<boolean>(false);

  readonly selectedIdList = input<number[]>([]);

  readonly selectionValidee = output<SelectionProduitComplementaire>();

  private readonly plcProduitComplementaireSvc = inject(PlcProduitComplementaireService);

  readonly paramSvc = inject(ProduitComplementaireParametrageService);

  readonly catalogueList = this.plcProduitComplementaireSvc.catalogueList;
  readonly catalogueTotal = this.plcProduitComplementaireSvc.catalogueTotalSignal;
  readonly cataloguePage = this.plcProduitComplementaireSvc.cataloguePageSignal;

  readonly currentIdList = signal<number[]>([]);

  private readonly declinaisonByIdMap = new Map<number, ProduitDeclinaisonComplementaireDTO>();

  onShowing = (): void => {
    this.currentIdList.set([...this.selectedIdList()]);
    this.declinaisonByIdMap.clear();
    this.plcProduitComplementaireSvc.openCatalogue();
  };

  /** Libère le catalogue : inutile de le garder chargé dialogue fermé. */
  onHiding = (): void => this.plcProduitComplementaireSvc.closeCatalogue();

  onSearchChanged = (event: ValueChangedEvent): void =>
    this.plcProduitComplementaireSvc.searchCatalogue(event.value ?? '');

  onPageIndexChange = (page: number): void => this.plcProduitComplementaireSvc.goToCataloguePage(page);

  /**
   * La grille ne connaît que la page courante : la sélection des autres pages est conservée telle quelle,
   * seules les lignes visibles suivent les cases à cocher.
   */
  onSelectionChanged = (event: SelectionChangedEvent): void => {
    (event.selectedRowsData ?? []).forEach(declinaison => this.declinaisonByIdMap.set(declinaison.id, declinaison));

    const pageIdList = this.catalogueList().map(declinaison => declinaison.id);
    const selectedIdSet = new Set((event.selectedRowKeys ?? []) as number[]);

    const idList = [
      ...this.currentIdList().filter(id => !pageIdList.includes(id)),
      ...pageIdList.filter(id => selectedIdSet.has(id))
    ];
    if (!this.isSameSelection(idList)) {
      this.currentIdList.set(idList);
    }
  };

  private isSameSelection = (idList: number[]): boolean => {
    const currentIdList = this.currentIdList();
    return currentIdList.length === idList.length && idList.every(id => currentIdList.includes(id));
  };

  valider = (): void => {
    const idList = this.currentIdList();
    this.selectionValidee.emit({
      idList,
      declinaisonList: idList.map(id => this.declinaisonByIdMap.get(id)).filter(declinaison => !!declinaison)
    });
    this.visible.set(false);
  };

  fermer = (): void => this.visible.set(false);
}
